import React from 'react';
import PropTypes from 'prop-types';

const Upi = ({ fill = '#434343', width, height = '20px' }) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 18 23"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>UPI</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="UPI" transform="translate(-9.000000, -7.000000)" fill={fill}>
        <g id="back-arrow">
          <g id="UPI" transform="translate(9.000000, 6.000000)">
            <path
              d="M8.08946373,2.63863275 L4.64072096,21.6113699 C4.49700733,22.4019887 5.0214276,23.1594148 5.81204641,23.3031284 C6.23937974,23.3808064 6.67907102,23.263512 7.01093361,22.983307 L17.2878329,14.3061047 C17.8522154,13.8295737 17.9699829,13.0057708 17.5617235,12.390195 L10.733567,2.09466008 C10.2894256,1.42498098 9.3864956,1.24214659 8.71681651,1.68628803 C8.38682233,1.90514522 8.16028073,2.24904376 8.08946373,2.63863275 Z M9.04382506,2.81211045 C9.06743072,2.68224745 9.14294459,2.5676146 9.25294265,2.49466221 C9.47616902,2.34661506 9.77714567,2.40755986 9.92519281,2.63078622 L16.7533493,12.9263211 C16.8894358,13.131513 16.85018,13.406114 16.6620525,13.5649577 L6.38515317,22.24216 C6.27453231,22.3355616 6.12796855,22.3746598 5.9855241,22.3487671 C5.7219845,22.3008626 5.54717775,22.0483872 5.59508229,21.7848476 L9.04382506,2.81211045 Z"
              id="Path-Copy"
              fillRule="nonzero"
            />
            <path
              d="M4.21406764,2.32814106 L0.510285462,21.6874224 C0.406505596,22.2298689 0.76211515,22.7537389 1.30456163,22.8575187 C1.59230042,22.9125684 1.88970703,22.8386747 2.11822096,22.6553567 L13.1551115,13.8013681 C13.5657316,13.4719613 13.6506623,12.8806179 13.3493487,12.4489609 L6.01624036,1.94366824 C5.70012202,1.49080221 5.07673702,1.37994631 4.62387099,1.69606465 C4.41010121,1.84528438 4.26305563,2.07208594 4.21406764,2.32814106 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Upi.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default Upi;
